import { render, staticRenderFns } from "./AirticketorderdetailsRight.vue?vue&type=template&id=5ed97310&scoped=true"
import script from "./AirticketorderdetailsRight.vue?vue&type=script&lang=js"
export * from "./AirticketorderdetailsRight.vue?vue&type=script&lang=js"
import style0 from "./AirticketorderdetailsRight.vue?vue&type=style&index=0&id=5ed97310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed97310",
  null
  
)

export default component.exports